import { useNumberFormat } from '../../lib/numberFormat';

/** Financial table with sticky labels/periods, [ACT]/[FCST] markers, parentheses negatives and drill-through. */
export function FinTable({ rows, labels, values, currency, onRowClick, actualCount = 0, testId = 'fin-table' }) {
  const { fmt } = useNumberFormat();
  return <div className="max-h-[70vh] overflow-auto rounded-lg border border-border bg-card shadow-sm" data-testid={testId}>
    <table className="fin-table w-full border-separate border-spacing-0">
      <thead>
        <tr>
          <th className="min-w-[180px] sm:min-w-[260px]">Line item</th>
          <th className="min-w-[70px] text-left">Unit</th>
          {labels.map((l, i) => <th key={l + i} className={`min-w-[104px] text-right ${actualCount > 0 && i === actualCount ? 'fcst-start' : ''}`}>
            <span className="mr-1 rounded border border-border px-1 text-[10px] font-semibold text-muted-foreground">{i < actualCount ? 'ACT' : 'FCST'}</span>{l}
          </th>)}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, ri) => {
          if (row.kind === 'section') return <tr key={ri} className="section"><td>{row.label}</td><td /><td colSpan={labels.length} /></tr>;
          const series = values[row.key] || [];
          const clickable = onRowClick && row.expr && row.kind !== 'check';
          return <tr key={row.key} className={`${row.bold ? 'bold' : ''} ${clickable ? 'clickable' : ''}`} onClick={clickable ? () => onRowClick(row) : undefined}
            tabIndex={clickable ? 0 : undefined} onKeyDown={clickable ? (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onRowClick(row); } } : undefined} data-testid={`row-${row.key}`}>
            <td>{row.label}</td>
            <td className="text-xs text-muted-foreground">{row.unit === 'currency' ? currency : row.unit}</td>
            {series.map((v, i) => <td key={i} data-testid={`${testId}-cell-${row.key}-${i}`} className={`num ${v < -0.005 ? 'neg' : ''} ${i >= actualCount ? 'fcst' : ''} ${actualCount > 0 && i === actualCount ? 'fcst-start' : ''}`}>{fmt(v, row.unit, currency, { symbol: false })}</td>)}
          </tr>;
        })}
      </tbody>
    </table>
  </div>;
}
